import { render, staticRenderFns } from "./svg-sedan.vue?vue&type=template&id=7ee27688&scoped=true"
import script from "./svg-sedan.vue?vue&type=script&setup=true&lang=ts"
export * from "./svg-sedan.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./svg-sedan.vue?vue&type=style&index=0&id=7ee27688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee27688",
  null
  
)

export default component.exports